<template>
  <div id="app">
    <layout-header :page="page"></layout-header>
    <router-view :page="page"/>
    <layout-footer>
    </layout-footer>
    <cookie-law theme="dark-lime" buttonText="J’accepte">
      <div slot="message">
        Ce site utilise des cookies. Si vous les acceptez, le responsable du site pourra recueillir des statistiques de visites anonymes pour améliorer la navigation. <router-link :to="{ name: 'legal-notices' }">En savoir plus.</router-link>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import api from '@/services/api';
import { Header, Footer } from './components';

export default {
  name: 'app',
  components: {
    'layout-header': Header,
    'layout-footer': Footer,
    CookieLaw,
  },
  data() {
    return {
      page: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.page = null;
      this.page = await api.getPage(this.$route.meta.contentId);
    },
  },
};
</script>

<style lang="sass">

</style>
